import React from 'react'

import './ModalRestricted.scss'
import Button from 'components/Button'

function ModalRestricted({isOpen, onConfirm}) {
    const [isChecked, setIsChecked] = React.useState(false)

  if (!isOpen) return null

  const handleContinue = () => {
    if (isChecked) {
      onConfirm?.()
    }
  }

  return (
    <div className='modal-restricted'>
      <div className='modal-restricted__container'>
        <div className='modal-container-header'>
          <span className='icon-ic-alert'></span>
          <p>Certain Features Unavailable In Vietnam</p>
        </div>

        <div className='modal-container-body'>
          <div className="body-content">
            In compliance with Vietnamese regulations on digital asset trading, certain features of this website (including digital asset trading) are currently unavailable in Vietnam.
          </div>

          <div className="body-check" onClick={() => setIsChecked(!isChecked)}>
            <div className={`checkbox ${isChecked && 'checkbox--is-active'}`}>
              <span className={`icon-ic-check checked-icon ${isChecked && 'checked-icon--is-active'}`}></span>
            </div>
            <div className="checkbox-label">
              I confirm that I am not a citizen or resident of Vietnam
            </div>
          </div>

          <Button className={`continue-button ${!isChecked && 'continue-button--disabled'}`} onClick={handleContinue}>
            Continue
          </Button>

          <div className="body-text-foot">
            Users are responsible for ensuring that their use of this service complies with the laws applicable in their jurisdiction. Thank you for your understanding.
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalRestricted